import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
import { Table } from 'reactstrap';

import DatePicker from 'react-datepicker';

export const ButtonNextPrev = styled.button`
	height: 100%;
	width: 100%;
	border-radius: 5px;
	border: 2px solid;
	border-color: ${color.primary};
	padding: 10px;
	transition: 1s all ease;
	background: #fff;
	color: ${color.primary};
	margin: 0;

	&:hover{
		background: ${color.primary};
		color: #fff;
		border-color: ${color.green};
	}

	&:disabled{
		background: ${color.grayMedium};
		color: #fff;
		border-color: ${color.grayMedium};
	}

	@media screen and (max-width: 762px){
		padding: 2px;
	}
`;


export const InputSelect = styled.select`
	text-align: center;
	background-color: ${color.primary};
	height: 100%;
	width: 100%;
	padding: 0;
	border: none;
	border-radius: 5px;
	transition: 1s all ease;
	margin: 0;
	font-weight: bold;

	option {
		background-color: #fff;
	}
`;

export const InputYear = styled(DatePicker)`
	text-align: center;
	background-color: ${color.primary};
	height: 50px;
	width: inherit;
	padding: 0;
	border: none;
	border-radius: 5px;
	transition: 1s all ease;
	margin: 0;
	font-weight: bold;
`;

export const TableAgenda = styled(Table)`

	thead{
		tr{
			height: 35px;
			.day-label {
				width: 14%;
			}

			.day-label:after {
				content: '';
				position: absolute;
				bottom: -1px;
				left: 0;
				width: 100%;
				height: 1px;
				background-color: transparent;
			}
			th {
				font-size: 15px;
				font-weight: bold;
				background-color: ${color.primary};
				padding: 0px;
				text-align: center;
				border-radius: 14px;
				border: 5px solid #fff;
			}
		}
	}

	tbody{
		.empty-area{
			background-color: ${color.greenLight2};
			boder: 3px solid #fff;
			border-radius: 8px;
			margin: 3px;
			height: 110px;
			display: flex;
			color: transparent;
		}

		.normal-day{
			height: 110px;
			border: 4px solid #fff;
		}

		.active-day{
			height: 110px;
			border: 4px solid ${color.primary};
			border-radius: 8px;
		}
		.box-second{
			background-color: ${color.primary};
		}
		.box-first{
			background-color: ${color.secondary};
		}
		.box-third{
			color: #fff;
			background-color: ${color.redMedium};
		}

		p{
			margin: 5px;
			text-align: center;
			border-radius: 5px 5px 0px 5px;
			font-size: 10px;
		}

		.box-day-area{
			height: 100%;
			display: flex;
			flex-direction: column;
			border-radius: 10px;
			border: 2px solid #ddd;
			margin: 2px;
			text-align: end;
			cursor: pointer;
			span {
				margin: 10px;
				font-size: 12px;
			}
		}

		tr{
			border-top: 2px solid #fff;
			td {
				font-weight: bold;
				padding: 0px;
			}
		}
	}

	@media screen and (max-width: 762px){
		padding: 0px;
		margin: 0px;
		thead{
			tr{
				th {
					font-size: 10px;
				}
			}
		}

		tbody{
			.empty-area, .normal-day, .active-day{
				height: 65px;
				font-size: 8px;
			}

			p, .box-third{
				margin: 3px;
				font-size: 8px;
			}

			.box-day-area{

				span {
					margin: 1px;
					font-size: 9px;
				}
			}

			tr{
				border-top: 2px solid #fff;
				td {

					font-weight: bold;
					padding: 0px;
				}
			}
		}
	}
`;
